module.exports = __webpack_public_path__ + "fonts/Manrope.946beb94.ttf";